/**
 * Origin облака для FileUpload7 (как Yii AvatarCloud::getServer()): без завершающего `/`.
 */
export const getCloudOrigin = () => {
  const raw = process.env.REACT_APP_FW_CLOUD_ORIGIN || "";
  return raw.replace(/\/$/, "").trim();
};
